module.exports = __webpack_public_path__ + "media/images/pc/items/gift/gift_thanks_01-ea01ffd796219f1fb67f75d0c5359db2.jpg";